<template>
  <div class="network-page">
    <section class="network-hero">
      <h1>{{ $t('network.title') }}</h1>
      <p>{{ $t('network.subtitle') }}</p>
    </section>

    <section class="network-stats">
      <div class="stat-item">
        <h3>100+</h3>
        <p>{{ $t('network.stats.nodes') }}</p>
      </div>
      <div class="stat-item">
        <h3>60+</h3>
        <p>{{ $t('network.stats.countries') }}</p>
      </div>
      <div class="stat-item">
        <h3>497Tbps+</h3>
        <p>{{ $t('network.stats.bandwidth') }}</p>
      </div>
      <div class="stat-item">
        <h3>99.99%</h3>
        <p>{{ $t('network.stats.availability') }}</p>
      </div>
    </section>

    <section class="network-regions">
      <h2>{{ $t('network.regions.title') }}</h2>
      <div class="region-list">
        <div class="region-item">
          <h3>{{ $t('network.regions.europe.title') }}</h3>
          <p>{{ $t('network.regions.europe.desc') }}</p>
        </div>
        <div class="region-item">
          <h3>{{ $t('network.regions.asia.title') }}</h3>
          <p>{{ $t('network.regions.asia.desc') }}</p>
        </div>
        <div class="region-item">
          <h3>{{ $t('network.regions.america.title') }}</h3>
          <p>{{ $t('network.regions.america.desc') }}</p>
        </div>
      </div>
    </section>

    <section class="coverage">
      <div class="section-header">
        <h2>{{ $t('home.coverage.title') }}</h2>
        <p>{{ $t('home.coverage.subtitle') }}</p>
      </div>
      <div class="map" ref="mapContainer">
        <img v-for="city in cities"
             :key="city.name"
             :src="src"
             :style="{ left: city.left, top: city.top }"
             @mouseover="showTooltip(city)"
             @mouseout="hideTooltip"
             alt="">
        <div v-if="tooltipVisible" class="tooltip">
          {{ tooltipText }}
        </div>
      </div>
      <div class="coverage-grid">
        <div class="coverage-region">
          <h3>North America</h3>
          <ul>
            <li>Ashburn*</li>
            <li>Atlanta*</li>
            <li>Boston</li>
            <li>Calgary</li>
            <li>Chicago*</li>
            <li>Columbus</li>
            <li>Dallas*</li>
            <li>Denver</li>
            <li>Detroit</li>
            <li>Honolulu</li>
            <li>Houston</li>
            <li>Jacksonville</li>
            <li>Kansas City</li>
            <li>Los Angeles*</li>
            <li>Miami</li>
            <li>Minneapolis</li>
            <li>Montreal</li>
            <li>New York*</li>
            <li>Phoenix</li>
            <li>Portland</li>
            <li>San Jose*</li>
            <li>Seattle*</li>
            <li>St Louis</li>
            <li>Toronto</li>
            <li>Vancouver</li>
          </ul>
        </div>

        <div class="coverage-region">
          <h3>South America</h3>
          <ul>
            <li>Bogota</li>
            <li>Buenos Aires</li>
            <li>Curitiba</li>
            <li>Fortaleza</li>
            <li>Lima</li>
            <li>São Paulo*</li>
            <li>Santiago</li>
            <li>Rio de Janeiro</li>
          </ul>
        </div>

        <div class="coverage-region">
          <h3>Europe</h3>
          <ul>
            <li>Amsterdam</li>
            <li>Copenhagen</li>
            <li>Brussels</li>
            <li>Dublin</li>
            <li>Frankfurt*</li>
            <li>Helsinki</li>
            <li>Lisbon</li>
            <li>London*</li>
            <li>Madrid</li>
            <li>Manchester</li>
            <li>Marseille</li>
            <li>Milan</li>
            <li>Munich</li>
            <li>Oslo</li>
            <li>Palermo</li>
            <li>Paris</li>
            <li>Rome</li>
            <li>Sofia</li>
            <li>Stockholm</li>
            <li>Vienna</li>
          </ul>
        </div>

        <div class="coverage-region">
          <h3>Africa</h3>
          <ul>
            <li>Accra</li>
            <li>Cape Town</li>
            <li>Johannesburg</li>
          </ul>
        </div>

        <div class="coverage-region">
          <h3>Asia</h3>
          <ul>
            <li>Bangkok</li>
            <li>Chennai</li>
            <li>Dubai</li>
            <li>Fujairah</li>
            <li>Hong Kong</li>
            <li>Hyderabad</li>
            <li>Kolkata</li>
            <li>Kuala Lumpur</li>
            <li>Manila</li>
            <li>Mumbai</li>
            <li>New Delhi</li>
            <li>Osaka</li>
            <li>Seoul</li>
            <li>Singapore</li>
            <li>Tokyo*</li>
          </ul>
        </div>

        <div class="coverage-region">
          <h3>Australia & New Zealand</h3>
          <ul>
            <li>Adelaide</li>
            <li>Auckland</li>
            <li>Brisbane</li>
            <li>Christchurch</li>
            <li>Melbourne</li>
            <li>Perth</li>
            <li>Sydney</li>
            <li>Wellington</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'NetworkPage',
  data() {
    return {
      src: require('@/assets/images/coordinate-icon.png'),
      cities: [
        {
          name: 'Ashburn*',
          left: '29.28%',
          top: '42%'
        },
        {
          name: 'Dallas*',
          left: '29.28%',
          top: '42%'
        },
        {
          name: 'Kansas City',
          left: '25.4%',
          top: '42.0%'
        },
        {
          name: 'Phoenix',
          left: '21.0%',
          top: '44%'
        },
        {
          name: 'Vancouver',
          left: '18.45%',
          top: '37.4%'
        },
        {
          name: 'Atlanta*',
          left: '27.8%',
          top: '44.2%'
        },
        {
          name: 'Denver',
          left: '23.4%',
          top: '42.0%'
        },
        {
          name: 'Los Angeles*',
          left: '19.9%',
          top: '44.0%'
        },
        {
          name: 'Portland',
          left: '18.5%',
          top: '39.1%'
        },
        {
          name: 'Boston',
          left: '30.9%',
          top: '40.5%'
        },
        {
          name: 'Detroit',
          left: '28.3%',
          top: '40.8%'
        },
        {
          name: 'Miami',
          left: '28.7%',
          top: '47.1%'
        },
        {
          name: 'San Jose*',
          left: '18.45%',
          top: '41.4%'
        },
        {
          name: 'Calgary',
          left: '19.7%',
          top: '36.4%'
        },
        {
          name: 'Honolulu',
          left: '10.15%',
          top: '48.95%'
        },
        {
          name: 'Minneapolis',
          left: '19.2%',
          top: '36.4%'
        },
        {
          name: 'Seattle*',
          left: '18.5%',
          top: '38.4%'
        },
        {
          name: 'Chicago*',
          left: '27.09%',
          top: '40.95%'
        },
        {
          name: 'Houston',
          left: '25.5%',
          top: '45.45%'
        },
        {
          name: 'Montreal',
          left: '30.2%',
          top: '39.4%'
        },
        {
          name: 'St Louis',
          left: '26.9%',
          top: '41.9%'
        },
        {
          name: 'Columbus',
          left: '28.15%',
          top: '41.9%'
        },
        {
          name: 'Jacksonville',
          left: '28.5%',
          top: '45.9%'
        },
        {
          name: 'New York*',
          left: '30.4%',
          top: '40.9%'
        },
        {
          name: 'Toronto',
          left: '28.9%',
          top: '40.1%'
        },
        {
          name: 'Bogota',
          left: '30.2%',
          top: '55.1%'
        },
        {
          name: 'Santiago',
          left: '31.1%',
          top: '69.2%'
        },
        {
          name: 'Buenos Aires',
          left: '34.1%',
          top: '69.3%'
        },
        {
          name: 'Rio de Janeiro',
          left: '37.5%',
          top: '65.1%'
        },
        {
          name: 'Curitiba',
          left: '36.1%',
          top: '66.1%'
        },
        {
          name: 'Fortaleza',
          left: '38.4%',
          top: '58.1%'
        },
        {
          name: 'Lima',
          left: '29.8%',
          top: '61.1%'
        },
        {
          name: 'São Paulo*',
          left: '36.8%',
          top: '65.2%'
        },
        {
          name: 'Amsterdam',
          left: '49.0%',
          top: '37.0%'
        },
        {
          name: 'Helsinki',
          left: '53.8%',
          top: '32%'
        },
        {
          name: 'Helsinki',
          left: '49.3%',
          top: '40%'
        },
        {
          name: 'Paris',
          left: '49.0%',
          top: '37.9%'
        },
        {
          name: 'Copenhagen',
          left: '51.0%',
          top: '34.5%'
        },
        {
          name: 'Lisbon',
          left: '46%',
          top: '42.0%'
        },
        {
          name: 'Milan',
          left: '50.3%',
          top: '39%'
        },
        {
          name: 'Rome',
          left: '51.0%',
          top: '40.8%'
        },
        {
          name: 'Brussels',
          left: '49%',
          top: '36.6%'
        },
        {
          name: 'London*',
          left: '47.9%',
          top: '36.6%'
        },
        {
          name: 'Munich',
          left: '50.9%',
          top: '37.9%'
        },
        {
          name: 'Sofia',
          left: '53.6%',
          top: '40.9%'
        },
        {
          name: 'Dublin',
          left: '46.4%',
          top: '35.6%'
        },
        {
          name: 'Madrid',
          left: '47.0%',
          top: '41.6%'
        },
        {
          name: 'Oslo',
          left: '50.6%',
          top: '32.2%'
        },
        {
          name: 'Stockholm',
          left: '52.25%',
          top: '32.45%'
        },
        {
          name: 'Frankfurt*',
          left: '50%',
          top: '37.45%'
        },
        {
          name: 'Manchester',
          left: '47.4%',
          top: '35.5%'
        },
        {
          name: 'Palermo',
          left: '51.2%',
          top: '42.57%'
        },
        {
          name: 'Vienna',
          left: '52.2%',
          top: '38.6%'
        },
        {
          name: 'Accra',
          left: '48%',
          top: '54.6%'
        },
        {
          name: 'Cape Town',
          left: '52.6%',
          top: '69.2%'
        },
        {
          name: 'Johannesburg',
          left: '54.6%',
          top: '66.1%'
        },
        {
          name: 'Adelaide',
          left: '81.4%',
          top: '69.4%'
        },
        {
          name: 'Sydney',
          left: '84.25%',
          top: '69.35%'
        },
        {
          name: 'Auckland',
          left: '89.9%',
          top: '70.45%'
        },
        {
          name: 'Wellington',
          left: '90.1%',
          top: '71.8%'
        },
        {
          name: 'Brisbane',
          left: '84.7%',
          top: '66.8%'
        },
        {
          name: 'Christchurch',
          left: '89.4%',
          top: '73.2%'
        },
        {
          name: 'Melbourne',
          left: '82.8%',
          top: '70.8%'
        },
        {
          name: 'Perth',
          left: '75.9%',
          top: '67.8%'
        },
        {
          name: 'Bangkok',
          left: '72.25%',
          top: '51.8%'
        },
        {
          name: 'Kolkata',
          left: '69.25%',
          top: '48%'
        },
        {
          name: 'Seoul',
          left: '78.6%',
          top: '42.9%'
        },
        {
          name: 'Chennai',
          left: '67.2%',
          top: '52.3%'
        },
        {
          name: 'Kuala Lumpur',
          left: '72.5%',
          top: '55.6%'
        },
        {
          name: 'Singapore',
          left: '72.9%',
          top: '56.2%'
        },
        {
          name: 'Dubai',
          left: '61.2%',
          top: '47.8%'
        },
        {
          name: 'Manila',
          left: '77.2%',
          top: '51.2%'
        },
        {
          name: 'Tokyo*',
          left: '81.5%',
          top: '43.2%'
        },
        {
          name: 'Fujairah',
          left: '61.7%',
          top: '48%'
        },
        {
          name: 'Mumbai',
          left: '65.8%',
          top: '50%'
        },
        {
          name: 'Hong Kong',
          left: '75.45%',
          top: '48.4%'
        },
        {
          name: 'New Delhi',
          left: '66.45%',
          top: '47.4%'
        },
        {
          name: 'Hyderabad',
          left: '66.9%',
          top: '50.5%'
        },
        {
          name: 'Osaka',
          left: '80.8%',
          top: '43.9%'
        },
      ],
      tooltipVisible: false,
      tooltipText: '',
    };
  },
  methods: {
    showTooltip(city) {
      this.tooltipText = city.name; // 显示城市名称作为提示
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    }
    // updateMapDimensions() {
    //   const mapContainer = this.$refs.mapContainer;
    //   this.mapWidth = mapContainer.clientWidth;
    //   console.log(this.mapWidth)
    //   this.mapHeight = mapContainer.clientHeight;
    //   console.log(this.mapHeight)
    // }
  }
};
</script>

<style scoped>
.network-page {
  background-color: var(--background-light);
  min-height: 100vh;
}

.network-hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  margin-bottom: 3rem;
}

.network-hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.network-hero p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.network-stats {
  max-width: 1200px;
  margin: 0 auto 3rem;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  text-align: center;
}

.stat-item {
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
}

.stat-item h3 {
  color: var(--primary-color);
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.stat-item p {
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.network-regions {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.network-regions h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: var(--text-primary);
  font-size: 2rem;
}

.region-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.region-item {
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.region-item:hover {
  transform: translateY(-5px);
  border-color: var(--primary-color);
}

.region-item h3 {
  color: var(--text-primary);
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.region-item p {
  color: var(--text-secondary);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .network-hero h1 {
    font-size: 2rem;
  }

  .stat-item h3 {
    font-size: 2rem;
  }
}

.coverage {
  padding: 3rem 2rem 6rem;
  background-color: var(--background-gray);
}

.section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.1rem;
  color: var(--text-secondary);
}

.map {
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  height: auto;
  aspect-ratio: 1200 / 800; /* 宽高比 1200:800（即 3:2） */
  background: var(--background-gray) url("@/assets/images/map.png") center no-repeat;
  background-size: 100% auto;
  margin: 2rem auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
  border-radius: 12px;
}

.map img {
  position: absolute;
  height: 16px;
  width: 18px
}

.map .tooltip {
  position: absolute;
  top: 20px;
  left: 550px;
  background-color: var(--primary-color);
  color: white;
  padding: 5px;
  border-radius: 5px;
  z-index: 1000;
}

.coverage-grid {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.coverage-region {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.coverage-region:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.coverage-region h3 {
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.coverage-region ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
}

.coverage-region ul li {
  color: var(--text-secondary);
  margin-bottom: 0.3rem;
  padding-left: 1rem;
  position: relative;
  flex: 0 1 150px;
}

.coverage-region ul li::before {
  content: "•";
  color: var(--primary-color);
  position: absolute;
  left: 0;
  font-weight: bold;
}

@media (max-width: 768px) {
  .coverage-grid {
    flex-direction: column;
  }

  .map img {
    height: 8px;
    width: 10px;
  }
}
</style> 